import { render } from "./AdminNotifications.vue?vue&type=template&id=5167f7a8&scoped=true"
import script from "./AdminNotifications.vue?vue&type=script&lang=js"
export * from "./AdminNotifications.vue?vue&type=script&lang=js"

import "./AdminNotifications.vue?vue&type=style&index=0&id=5167f7a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5167f7a8"]])

export default __exports__